export default {
  lang: {
    confirm: {
      title: 'តើ អ្នក ពិត ជា ចង់ លុប វា ឬ ? អ្នក មិន អាច ស្ដារ វា បាន ទេ បន្ទាប់ ពី លុប',
      okText: 'លុប',
      cancelText: 'បោះបង់',
    },
  },
};
